export default "__VITE_PUBLIC_ASSET__37d042e3__"